import { Injectable } from '@angular/core';
import { CanvasService } from '../../services/canvas/canvas.service';
import { AnimationService } from '../animation/animation.service';
import { HttpService } from '../../store/http/http.service';
import { setExportIsInProgress } from '../store/editor.actions';
import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RecorderService {
  constructor(
    private readonly cs: CanvasService,
    private readonly animationService: AnimationService,
    private readonly httpService: HttpService,
    private readonly http: HttpClient,
    private readonly store: Store,
  ) {}

  async export() {
    this.state = 'recording';
    console.time('recording:full');
    console.time('recording:prepare');

    this.store.dispatch(setExportIsInProgress({ value: true }));
    this.state = 'load-resources';
    this.cs.previewShape.__setPreAnimationState();
    await this.animationService.audioService.waitForAudioFiles();
    const { stop, getRecording } = await this.startRecording();

    console.timeEnd('recording:prepare');

    console.time('recording:play');
    // await this.cs.waitForsoundFilesAndPlay();
    console.log('------ canvas.comp >> playAnimations');
    this.animationService.audioService.startBackgroundMusic();
    this.state = 'recording';
    this.cs.generalEventSubscribe('animation-finished', async () => {
      stop();
      console.timeEnd('recording:play');

      console.time('recording:rendering');

      const recording = await getRecording();
      const recordedChunks: Uint8Array[] = [];
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { value, done } = await recording.read();
        console.log('Received', value, done);
        if (done) break;
        recordedChunks.push(value);
      }

      const blob = new Blob(recordedChunks, { type: 'video/mp4' });
      console.log({ size: blob.size });
      const url = URL.createObjectURL(blob);

      await this.downloadRecording(url);

      this.store.dispatch(setExportIsInProgress({ value: false }));
      // return;
      console.timeEnd('recording:rendering');

      console.time('recording:downloading');
      // const webmBlob = await fetch(url).then(res => res.blob());

      // console.log('start converting', webmBlob);
      // const mp4Blob = await this.convertWebMtoMP4(url);
      // console.log('end converting');

      // const mp4Blob = await this.httpService
      //   .convertWebmToMp4(new File([webmBlob], 'recording.webm'))
      //   .toPromise();
      // await this.downloadRecordingMP4(mp4Blob);
      console.timeEnd('recording:downloading');
      console.timeEnd('recording:full');
    });
    await this.animationService.playAnimations();
  }

  async startRecording() {
    const canvas = this.cs.canvasNativeElement.firstChild as HTMLCanvasElement;

    if (!canvas) {
      console.warn('Missing canvas');
      return;
    }

    const videoStream = canvas.captureStream(50);
    const audioContext = await this.animationService.audioContext;
    const audioStream = await this.animationService.audioDestination;

    const mediaTracks = new MediaStream(
      [].concat(videoStream.getTracks()).concat(audioStream.stream.getTracks()),
    );

    const recorder = new MediaRecorder(mediaTracks, {
      mimeType: 'video/webm; codecs=vp9',
    });

    recorder.start();
    recorder.requestData();

    console.log('recorder data requested');

    (async () => {
      // play 2s empty sound
      const buffer = new AudioBuffer({
        numberOfChannels: 2,
        length: audioContext.sampleRate * 2.0,
        sampleRate: audioContext.sampleRate,
      });

      const source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(audioStream);
      source.start(0);

      console.log('playing 2s empty sound');
    })();

    const ready = new Promise<void>(resolve => {
      recorder.addEventListener('dataavailable', event => {
        if (event.data.size > 0) {
          resolve();
        } else {
          setTimeout(() => recorder.requestData(), 100);
        }
      });
    });

    let isClosed = false;
    let lastEvent: Promise<void>;
    const requestStream = new ReadableStream<Uint8Array>({
      start(controller) {
        recorder.ondataavailable = event => {
          console.log(event.data, event.data.size, isClosed);
          if (event.data.size > 0 && !isClosed) {
            lastEvent = event.data.arrayBuffer().then(buffer => {
              console.log('last event set');
              console.log('last event processed');
              controller.enqueue(new Uint8Array(buffer));
              console.log('request stream appended');
            });
          }
        };
        recorder.onstop = async () => {
          console.log('request stream stopped');
          await lastEvent;
          console.log('closing...');
          isClosed = true;
          controller.close();
        };
      },
    });

    const convertRequest = fetch(
      'https://dev.new-api.inwedio.com/video-convert/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'video/webm',
          Authorization: `Bearer ${this.httpService.getToken()}`,
        },
        body: requestStream,
        duplex: 'half',
      } as any,
    );

    // const recordingRequest = this.http.post(
    //   'http://localhost:8000',
    //   requestStream,
    //   {
    //     observe: 'events',
    //     responseType: 'arraybuffer',
    //     reportProgress: true,
    //   },
    // );

    // recordingRequest.subscribe(event => {
    //   console.log(event);
    // });

    await ready;

    const stop = () => recorder.stop();

    return {
      stop,
      getRecording: async () => (await convertRequest).body.getReader(),
    };
  }

  async downloadRecording(url: string) {
    const previousLink = document.querySelector('a#record-downloader');

    if (previousLink) {
      previousLink.remove();
    }

    const link$ = document.createElement('a');

    link$.id = 'record-downloader';
    link$.style.display = 'none';

    link$.setAttribute(
      'download',
      `${this.cs.currentFileID}-${+new Date()}.mp4`,
    );
    link$.setAttribute('href', url);

    document.body.appendChild(link$);

    link$.click();
  }

  state: 'idle' | 'load-resources' | 'recording' | 'finished' = 'idle';
}
